import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "clearfix" };
const _hoisted_3 = { class: "clearfix" };
const _hoisted_4 = {
    name: "componentSearch",
    class: "clearfix data-grid-top-pagination"
};
const _hoisted_5 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_6 = { class: "input-group top_search" };
const _hoisted_7 = { class: "input-group-btn" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* HOISTED */);
const _hoisted_9 = [
    _hoisted_8
];
const _hoisted_10 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_11 = { class: "checkbox-wrapper" };
const _hoisted_12 = {
    key: 0,
    class: "float-end"
};
const _hoisted_13 = { class: "clearfix" };
const _hoisted_14 = { class: "col-xs-12 col-sm-12 col-md-4 bottom10" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("label", null, "Code *", -1 /* HOISTED */);
const _hoisted_16 = { class: "col-xs-12 col-sm-12 col-md-8 bottom10" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("label", null, "Name *", -1 /* HOISTED */);
const _hoisted_18 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("label", null, "Type *", -1 /* HOISTED */);
const _hoisted_20 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12 bottom10"
};
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("label", null, "Serial Number", -1 /* HOISTED */);
const _hoisted_22 = {
    key: 1,
    class: "col-xs-12 col-sm-12 col-md-12 bottom10"
};
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("label", null, "Registration Key", -1 /* HOISTED */);
const _hoisted_24 = { class: "float-end float-start-sm" };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-refresh" }, null, -1 /* HOISTED */);
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
const _hoisted_29 = {
    name: "componentList",
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_30 = { class: "clearfix" };
const _hoisted_31 = { class: "card" };
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("div", { class: "card-header" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "card-title" }, "\r\n\t\t\t\t\t\t\t\t\t\tComponents\r\n\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_33 = {
    ref: "componentsDiv",
    class: "list-group list-group-flush overflow-y-auto",
    style: { "height": "calc(100vh - 290px)" }
};
const _hoisted_34 = { class: "float-start w40 hidden-sm" };
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* HOISTED */);
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* HOISTED */);
const _hoisted_38 = { class: "float-start" };
const _hoisted_39 = { class: "clearfix bottom5" };
const _hoisted_40 = ["onClick"];
const _hoisted_41 = { class: "clearfix" };
const _hoisted_42 = { class: "float-start" };
const _hoisted_43 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-server" }, null, -1 /* HOISTED */);
const _hoisted_44 = {
    key: 0,
    class: "list-group-item text-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_modal = _resolveComponent("b-modal");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_button_group = _resolveComponent("b-button-group");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                modelValue: _ctx.componentQuery.keywords,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.componentQuery.keywords) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: "Search for...",
                                onKeyup: _withKeys(_ctx.getSystemComponents, ["enter"]),
                                required: ""
                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                            _createTextVNode(),
                            _createElementVNode("span", _hoisted_7, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-default",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.getSystemComponents && _ctx.getSystemComponents(...args)))
                                }, _hoisted_9)
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_b_form_checkbox, {
                                id: "includeArchived",
                                modelValue: _ctx.componentQuery.includeDeleted,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.componentQuery.includeDeleted) = $event)),
                                size: "lg"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\tShow archived\r\n\t\t\t\t\t\t\t")
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue"])
                        ])
                    ]),
                    _createTextVNode(),
                    (_ctx.systemComponents)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createVNode(_component_b_pagination, {
                                class: "float-end",
                                modelValue: _ctx.pageNo,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.pageNo) = $event)),
                                "per-page": _ctx.pageSize,
                                "total-rows": _ctx.systemComponents.length,
                                "hide-ellipsis": true,
                                disabled: _ctx.working
                            }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_b_modal, {
                        id: "component_details",
                        modelValue: _ctx.editingComponent,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.editingComponent) = $event)),
                        "header-bg-variant": "normal",
                        size: "lg"
                    }, {
                        title: _withCtx(() => [
                            _createTextVNode("\r\n\t\t\t\t\t\t\tComponent\r\n\t\t\t\t\t\t")
                        ]),
                        footer: _withCtx(() => [
                            _createElementVNode("div", _hoisted_24, [
                                (!_ctx.disableControls)
                                    ? (_openBlock(), _createBlock(_component_b_button, {
                                        key: 0,
                                        type: "button",
                                        variant: "primary",
                                        onClick: _ctx.saveSystemComponent
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_25,
                                            _createTextVNode(" Save\r\n\t\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["onClick"]))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(),
                                (!_ctx.disableControls && !_ctx.isNewComponent && !_ctx.isArchivedComponent)
                                    ? (_openBlock(), _createBlock(_component_b_button, {
                                        key: 1,
                                        type: "button",
                                        variant: "danger",
                                        onClick: _cache[9] || (_cache[9] = ($event) => (_ctx.archiveSystemComponent(_ctx.component)))
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_26,
                                            _createTextVNode(" Archive\r\n\t\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(),
                                (!_ctx.disableControls && !_ctx.isNewComponent && _ctx.isArchivedComponent)
                                    ? (_openBlock(), _createBlock(_component_b_button, {
                                        key: 2,
                                        type: "button",
                                        variant: "warning",
                                        onClick: _cache[10] || (_cache[10] = ($event) => (_ctx.restoreSystemComponent(_ctx.component)))
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_27,
                                            _createTextVNode(" Restore\r\n\t\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                _createTextVNode(),
                                _createVNode(_component_b_button, {
                                    type: "button",
                                    variant: "secondary",
                                    onClick: _ctx.cancelSystemComponentChanges
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_28,
                                        _createTextVNode(" Close\r\n\t\t\t\t\t\t\t\t")
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["onClick"])
                            ])
                        ]),
                        default: _withCtx(() => [
                            _createTextVNode(),
                            _createVNode(_component_b_container, { clearfix: "" }, {
                                default: _withCtx(() => {
                                    var _a, _b, _c;
                                    return [
                                        _createElementVNode("div", _hoisted_14, [
                                            _hoisted_15,
                                            _createTextVNode(),
                                            _createVNode(_component_b_form_input, _mergeProps(_ctx.componentCodeVal, {
                                                name: "componentCode",
                                                type: "text",
                                                maxlength: "50",
                                                modelValue: _ctx.component.componentCode,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.component.componentCode) = $event)),
                                                modelModifiers: { trim: true },
                                                class: { 'is-invalid': (_a = _ctx.errors) === null || _a === void 0 ? void 0 : _a.componentCode },
                                                disabled: true
                                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class"])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_16, [
                                            _hoisted_17,
                                            _createTextVNode(),
                                            _createVNode(_component_b_form_input, _mergeProps(_ctx.componentNameVal, {
                                                name: "componentName",
                                                type: "text",
                                                maxlength: "150",
                                                modelValue: _ctx.component.componentName,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.component.componentName) = $event)),
                                                modelModifiers: { trim: true },
                                                class: { 'is-invalid': (_b = _ctx.errors) === null || _b === void 0 ? void 0 : _b.componentName },
                                                disabled: _ctx.disableControls
                                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class", "disabled"])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_18, [
                                            _hoisted_19,
                                            _createTextVNode(),
                                            _createVNode(_component_multiselect, _mergeProps(_ctx.componentTypeIdVal, {
                                                name: "componentTypeId",
                                                modelValue: _ctx.componentType,
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.componentType) = $event)),
                                                "track-by": "value",
                                                label: "text",
                                                placeholder: _ctx.selectPlaceholder,
                                                options: _ctx.componentTypes,
                                                showLabels: false,
                                                allowEmpty: false,
                                                class: { 'is-invalid': (_c = _ctx.errors) === null || _c === void 0 ? void 0 : _c.componentTypeId },
                                                disabled: true
                                            }), {
                                                noResult: _withCtx(() => [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 16 /* FULL_PROPS */, ["modelValue", "placeholder", "options", "class"])
                                        ]),
                                        _createTextVNode(),
                                        (!_ctx.isNewComponent)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                _hoisted_21,
                                                _createTextVNode(),
                                                _createVNode(_component_b_form_input, {
                                                    modelValue: _ctx.component.serialNumber,
                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.component.serialNumber) = $event)),
                                                    disabled: true
                                                }, null, 8 /* PROPS */, ["modelValue"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (!_ctx.isNewComponent)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                _hoisted_23,
                                                _createTextVNode(),
                                                _createVNode(_component_b_form_input, {
                                                    modelValue: _ctx.component.registrationKey,
                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.component.registrationKey) = $event)),
                                                    disabled: true
                                                }, null, 8 /* PROPS */, ["modelValue"])
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ];
                                }),
                                _: 1 /* STABLE */
                            }),
                            _createTextVNode()
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                                _hoisted_32,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_33, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemComponentsPage, (item) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            class: _normalizeClass(['list-group-item', !item.isActive ? 'deleted' : ''])
                                        }, [
                                            _createElementVNode("div", _hoisted_34, [
                                                _createVNode(_component_b_button_group, { class: "float-start" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_b_dropdown, {
                                                            variant: "outline-secondary dots",
                                                            size: "sm",
                                                            onClick: ($event) => (_ctx.editSystemComponent(item))
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_b_dropdown_item, {
                                                                    onClick: ($event) => (_ctx.editSystemComponent(item))
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _hoisted_35,
                                                                        _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                                                                _createTextVNode(),
                                                                (!_ctx.disableControls)
                                                                    ? (_openBlock(), _createBlock(_component_b_dropdown_divider, { key: 0 }))
                                                                    : _createCommentVNode("v-if", true),
                                                                _createTextVNode(),
                                                                (!_ctx.disableControls)
                                                                    ? _withDirectives((_openBlock(), _createBlock(_component_b_dropdown_item, {
                                                                        key: 1,
                                                                        onClick: ($event) => (_ctx.archiveSystemComponent(item))
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _hoisted_36,
                                                                            _createTextVNode(" Archive\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                        ]),
                                                                        _: 2 /* DYNAMIC */
                                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])), [
                                                                        [_vShow, item.isActive]
                                                                    ])
                                                                    : _createCommentVNode("v-if", true),
                                                                _createTextVNode(),
                                                                (!_ctx.disableControls)
                                                                    ? _withDirectives((_openBlock(), _createBlock(_component_b_dropdown_item, {
                                                                        key: 2,
                                                                        onClick: ($event) => (_ctx.restoreSystemComponent(item))
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _hoisted_37,
                                                                            _createTextVNode(" Restore\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                        ]),
                                                                        _: 2 /* DYNAMIC */
                                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])), [
                                                                        [_vShow, !item.isActive]
                                                                    ])
                                                                    : _createCommentVNode("v-if", true)
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1024 /* DYNAMIC_SLOTS */)
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_38, [
                                                _createElementVNode("div", _hoisted_39, [
                                                    _createElementVNode("a", {
                                                        href: "#",
                                                        class: "lead blue",
                                                        onClick: _withModifiers(($event) => (_ctx.editSystemComponent(item)), ["prevent"])
                                                    }, _toDisplayString(item.componentRef), 9 /* TEXT, PROPS */, _hoisted_40)
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("div", _hoisted_41, [
                                                    _createElementVNode("div", _hoisted_42, [
                                                        _hoisted_43,
                                                        _createTextVNode(" " + _toDisplayString(item.componentTypeName), 1 /* TEXT */)
                                                    ])
                                                ])
                                            ])
                                        ], 2 /* CLASS */));
                                    }), 256 /* UNKEYED_FRAGMENT */)),
                                    _createTextVNode(),
                                    (!_ctx.systemComponents.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, "\r\n\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t"))
                                        : _createCommentVNode("v-if", true)
                                ], 512 /* NEED_PATCH */)
                            ])
                        ])
                    ])
                ])
            ])
        ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.componentsLoaded]
        ])
    ]));
}
